import { useContext } from 'react'
import AuthContext from 'store/auth-context'

const useAuth = () => {
    const AuthCtx = useContext(AuthContext);
    return AuthCtx
}

export default useAuth;